<template lang="pug">
	VueFeedback(type="success")
		template(slot="feedback-title") {{ $t('success_title') }}
		template(slot="feedback-action")
			VueButton(@click="$emit('back')") {{ $t('back') }}
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import VueFeedback from '@ui-common/vue-feedback';
import { lang } from '../mixins/lang';

export default defineComponent({
	mixins: [lang],
	components: {
		VueFeedback
	},
	emits: ['back'],
	setup() {}
});
</script>

<style src="@ui-common/vue-feedback/dist/vue-feedback.css"></style>
<style lang="scss" scoped></style>
